import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: BASE });

export const getToken = () => localStorage.getItem("sonu_admin_token");
export const setToken = (t) =>
  t ? localStorage.setItem("sonu_admin_token", t) : localStorage.removeItem("sonu_admin_token");

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      setToken(null);
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e) {
  const d = e?.response?.data?.error?.detail ?? e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  return String(d);
}

export default api;
